import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Menu } from 'antd';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { QUERY_LANDLORD_COMPANY_INFO } from '../queries';
import PersonalInfo from './personal-info';
import CompanyInfo from './company-info';
import event from '~helpers/mixpanel';
import { pageType } from '~constants/pages';

const uesStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      width: '100%',
      height: 'calc(100vh - 108px)',
      paddingTop: 32,
      paddingBottom: 32,
      backgroundColor: theme.colors.gray1,
      borderRadius: theme.borderRadius.min,
    },
    menu: {
      ...theme.divider.dividerRight,
      width: 200,
      height: '100%',

      '& .ant-menu-item': {
        margin: 0,
      },

      '& .ant-menu-item-selected': {
        fontWeight: 'bold',
        borderRight: `2px solid ${theme.colors.mainGreen6}`,
      },
    },
  }),
  { name: 'MyProfile' },
);

const companyMenuItems = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  COMPANY_INFO: 'COMPANY_INFO',
};
const individualMenuItems = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  LANDLORD_INFO: 'landlord_info',
};
const MenuList = ({ selectedMenuKey, setSelectedMenuKey, bookingType }) => {
  const classes = uesStyles();
  const { t } = useTranslation();
  const menuItems = bookingType === 'INDIVIDUAL' ? individualMenuItems : companyMenuItems;
  const handleSelectedMenu = item => {
    setSelectedMenuKey(item?.key);
  };

  return (
    <Menu className={classes.menu} selectedKeys={[selectedMenuKey]}>
      <For of={Object.keys(menuItems)} each="item">
        <Menu.Item key={menuItems[item]} onClick={handleSelectedMenu}>
          {t(menuItems[item].toLowerCase())}
        </Menu.Item>
      </For>
    </Menu>
  );
};

MenuList.propTypes = {
  selectedMenuKey: PropTypes.string.isRequired,
  setSelectedMenuKey: PropTypes.func.isRequired,
};

const MyProfile = ({ userUuid }) => {
  const classes = uesStyles();
  const [selectedMenuKey, setSelectedMenuKey] = useState(companyMenuItems.PERSONAL_INFO);
  const { data } = useQuery(QUERY_LANDLORD_COMPANY_INFO, {
    variables: { userUuid },
  });
  const landlordCompanyData = data?.landlordContact?.company;
  const businessType = landlordCompanyData?.businessType;

  useEffect(() => {
    event('Viewed Account My Profile Page', { 'Current Page Type': pageType.myProfilePage });
  }, []);
  const menuItems = businessType === 'INDIVIDUAL' ? individualMenuItems : companyMenuItems;
  return (
    <div className={classes.root}>
      <MenuList
        bookingType={businessType}
        selectedMenuKey={selectedMenuKey}
        setSelectedMenuKey={setSelectedMenuKey}
      />
      <Choose>
        <When condition={selectedMenuKey === menuItems.PERSONAL_INFO}>
          <PersonalInfo userUuid={userUuid} />
        </When>
        <When
          condition={
            selectedMenuKey === menuItems.COMPANY_INFO ||
            selectedMenuKey === menuItems.LANDLORD_INFO
          }
        >
          <CompanyInfo userUuid={userUuid} landlordCompanyData={landlordCompanyData} />
        </When>
      </Choose>
    </div>
  );
};

MyProfile.propTypes = {
  userUuid: PropTypes.string.isRequired,
};

export default MyProfile;
